/* eslint-disable strict */
(function () {
    'use strict';

    angular.module('legitimationUpload')

        .factory('fallbackFactory', function fallbackFactory() {

            // Return public API.
            return {
                logoutAndRedirect: function (redirectUrl) {
                    $.get(GLOBALURLS.APIURL.LOGOUT);
                    setTimeout(function () {
                        window.location.href = redirectUrl;
                    }, 1000);

                },
            };

        })

        .factory('userService', ['$rootScope', '$http', '$q', '$injector', function ($rootScope, $http, $q, $injector) {

            // get global config
            var config = $injector.get('config');

            var userdata = {};

            return {

                isElegible: function () {
                    var eligibleSmartTariffs = ['SMART3E', 'SMART3LI', 'SMART3S', 'SMART3M', 'SMART3L', 'SMART3XL', 'SMART3XXL'];
                    var tariff = '';
                    try {
                        tariff = userdata.data.vfplan;
                    } catch (e) {}
                    if ((-1 < tariff.indexOf('YOUNG')) ||
                        (-1 < tariff.indexOf('YOU2')) ||
                        (-1 < tariff.indexOf('YOU3')) ||
                        (-1 < tariff.indexOf('GMY')) ||
                        (0 === tariff.indexOf('SM2')) ||
                        (-1 < tariff.indexOf('REPL2KOS')) ||
                        (-1 < tariff.indexOf('REPL2K05')) ||
                        (-1 < tariff.indexOf('REDPLKOS')) ||
                        (-1 < tariff.indexOf('REDPLKH5')) ||
                        (-1 < tariff.indexOf('REDPLDATK')) ||
                        -1 !== eligibleSmartTariffs.indexOf(tariff)) {
                        console.log('tariff ok');
                        return true;

                    } else {
                        console.log('tariff ! ok');
                        return false;
                    }

                },

                getData: function (url) {
                    var deferred = $q.defer();
                    $http.get(url)
                        .then(function (response) {
                            userdata = response;
                            $rootScope.$broadcast('bcstUserdata');
                            deferred.resolve(response);
                        }, function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                },

                checkLoginStatus: function () {
                    var deferred = $q.defer();
                    vf.bookservices.auth.checkLoggedInStatus({
                        url: config.APIURL.CHECKLOGIN,
                        onLoggedIn: function (data) {
                            deferred.resolve(data);
                        },
                        onNotLoggedIn: function (data) {
                            deferred.reject(data);
                        },
                        onError: function (data) {
                            deferred.reject(data);
                        }
                    });

                    return deferred.promise;
                },

                getUserdata: function () {
                    return userdata;
                },

                login: function (msisdn, password, go) {
                    var deferred = $q.defer();
                    vf.bookservices.auth.login({
                        options: {
                            go: go,
                            msisdn: msisdn,
                            cpass: password
                        },
                        onLoggedIn: function (data) {
                            deferred.resolve(data);
                        },
                        onLoginFailed: function (data) {
                            deferred.reject(data);

                        },
                        onError: function (data) {
                            deferred.reject(data);
                        }
                    });
                    return deferred.promise;
                },

                sendSmsCode: function (msisdn, go) {
                    var deferred = $q.defer();
                    vf.bookservices.auth.login({
                        options: {
                            go: go,
                            msisdn: msisdn,
                            pass: '',
                            smsTextKey: 'welcome'
                        },
                        onLoggedIn: function (data) {
                            deferred.resolve(data);

                        },
                        onLoginFailed: function (data) {
                            deferred.reject(data);
                        },
                        onError: function (data) {
                            deferred.reject(data);
                        }
                    });
                    return deferred.promise;
                },

                loginWithCode: function (msisdn, code, go) {
                    var deferred = $q.defer();
                    vf.bookservices.auth.login({
                        options: {
                            go: go,
                            msisdn: msisdn,
                            smsloginId: code
                        },
                        onLoggedIn: function (data) {
                            deferred.resolve(data);
                        },
                        onLoginFailed: function (data) {
                            deferred.reject(data);
                        },
                        onError: function (data) {
                            deferred.reject(data); ;
                        }
                    });
                    return deferred.promise;
                },

                logout: function () {
                    var deferred = $q.defer();
                    vf.bookservices.auth.logout({
                        onLogout: function (data) {
                            deferred.resolve(data);
                        },
                        onError: function (data) {
                            deferred.reject(data);
                        }
                    });
                    return deferred.promise;
                }
            };
        }])

        .factory('httpInterceptor', ['$rootScope', '$q', function ($rootScope, $q) {
            var requests = 0;
            return {
                request: function (config) {
                    requests++;
                    $rootScope.$broadcast('bcstLoadingSpinner_show');

                    return config || $q.when(config);
                },

                response: function (response) {
                    if (0 == (--requests)) {
                        $rootScope.$broadcast('bcstLoadingSpinner_hide');
                    }

                    return response || $q.when(response);
                },

                responseError: function (response) {
                    if (!--requests) {
                        $rootScope.$broadcast('bcstLoadingSpinner_hide');
                    }

                    return $q.reject(response);
                }
            };
        }])

        .factory('dateTimeFactory', function dateTimeFactory() {

            function getYearRange () {

                var now = new Date();
                var currentYear = now.getFullYear();

                // calculate year range for dropdown
                var years = [];
                for (var year = (currentYear - 27); year <= currentYear; year++) {
                    years.push(year);
                }

                return years;

            }

            function getLocaleDate () {

                var now = new Date();

                var day = now.getDate();
                var month = now.getMonth() + 1;
                var year = now.getFullYear();

                var dayString = 10 > day ? '0' + day.toString() : day.toString();
                var monthString = 10 > month ? '0' + month.toString() : month.toString();

                var ttmmyyyy = dayString + monthString + year.toString();

                return ttmmyyyy;

            }

            // Return public API.
            return {
                getYearRange: getYearRange,
                getLocaleDate: getLocaleDate
            };

        })

        .factory('stringHelper', function stringHelper() {

            return {

                decodeHtmlSpecialChar: function (html) {
                    var txt = document.createElement('textarea');
                    txt.innerHTML = html;
                    return txt.value;
                }

            };


        });



}());
